export default __webpack_public_path__ + "static/media/pikachu-background.11059f00.jfif";